import apiClient from "./axiosConfig";
import { getAccessToken } from "./authToken";

const SESSION_SYNC_KEY = "dople.session_sync_started_v1";
const SESSION_SYNC_LOCAL_KEY = "dople.session_sync_last_started_v1";
const SESSION_SYNC_DELAY_MS = 1200;
const SESSION_SYNC_COOLDOWN_MS = 10 * 60 * 1000;
const FINANCE_DATA_UPDATED_EVENT = "dople:finance-data-updated";
const SESSION_TRANSACTION_SYNC_ENABLED =
  String(process.env.REACT_APP_SESSION_TRANSACTION_SYNC_ENABLED || "").toLowerCase() === "true";
let sessionSyncPromise = null;

export function emitFinanceDataUpdated(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(FINANCE_DATA_UPDATED_EVENT, { detail }));
}

export function subscribeFinanceDataUpdated(callback) {
  if (typeof window === "undefined") return () => {};

  const handler = (event) => {
    callback(event.detail || {});
  };

  window.addEventListener(FINANCE_DATA_UPDATED_EVENT, handler);
  return () => window.removeEventListener(FINANCE_DATA_UPDATED_EVENT, handler);
}

export function markSessionSyncComplete() {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(SESSION_SYNC_KEY, "1");
  localStorage.setItem(SESSION_SYNC_LOCAL_KEY, String(Date.now()));
}

export function clearSessionSyncFlag() {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(SESSION_SYNC_KEY);
  localStorage.removeItem(SESSION_SYNC_LOCAL_KEY);
}

export function hasSessionSyncRun() {
  if (typeof window === "undefined") return false;
  if (sessionStorage.getItem(SESSION_SYNC_KEY) === "1") return true;
  const lastStarted = Number(localStorage.getItem(SESSION_SYNC_LOCAL_KEY) || 0);
  return Boolean(lastStarted && Date.now() - lastStarted < SESSION_SYNC_COOLDOWN_MS);
}

function delay(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

export function maybeStartSessionSync(status) {
  if (typeof window === "undefined") return null;
  if (!SESSION_TRANSACTION_SYNC_ENABLED) return null;
  if (!getAccessToken()) return null;
  if (!status?.appAccessGranted || !status?.hasPlaid) return null;
  if (hasSessionSyncRun() || sessionSyncPromise) return sessionSyncPromise;

  markSessionSyncComplete();

  sessionSyncPromise = delay(SESSION_SYNC_DELAY_MS)
    .then(async () => {
      try {
        await apiClient.post("/api/transactions/sync", null, { skipGlobalErrorToast: true });
        emitFinanceDataUpdated({ scope: "transactions" });
      } catch (err) {
        if (process.env.NODE_ENV !== "production") {
          console.warn("[sessionSync] transaction sync failed:", err?.response?.data || err);
        }
      }

      emitFinanceDataUpdated({ scope: "finance" });
      return null;
    })
    .finally(() => {
      sessionSyncPromise = null;
    });

  return sessionSyncPromise;
}
